<template>
  <div>
    <h3 id="try">Try it with your files</h3>
    <input type="file" id="user-file" @change="changeFile">
    <p>
      <i style="font-size: 13px;">
        Result will be converted to
        <code>gif</code> and downloaded to your
        device once the conversion is done
      </i>
    </p>
    <p>
      <i style="font-size: 13px;" id="error-on-try"></i>
    </p>
  </div>
</template>
<script>
const heic2any = require('heic2any')
  //   document.getElementById("user-file").addEventListener("change", function (ev) {
  //   console.log("aaa");
  //   document.getElementById("error-on-try").innerHTML = "";
  //   document.getElementById("error-on-try").style.display = "none";
  //   var blob = ev.target.files[0];
  //   heic2any({
  //     blob: blob,
  //     toType: "image/gif",
  //   })
  //     .then(function (resultBlob) {
  //       saveFile(resultBlob, blob.name + ".gif");
  //     })
  //     .catch(function (x) {
  //       document.getElementById("error-on-try").style.display = "block";
  //       document.getElementById("error-on-try").innerHTML =
  //         "Error code: <code>" + x.code + "</code> " + x.message;
  //     });
  // });
  export default {
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        old: {
            type: Array,
            default: [""]
        },
        imageUrl: {
            type: String,
            default: null
        },
        deleteUrl: {
            type: String,
            default: null
        },
        offset: {
            type: Number,
            default: 0
        },
        apiUrl: {
            type: String,
            default: null
        },
    },
    mounted() {
        console.log(this.apiUrl)
        // if(this.items.length == 0) {
        //      this.addBlock()
        // } else {
        //     this.blocks = this.items
        // }
    },
    data() {
        return {
            uploadFile: null
        }
    },
    methods: {
        async changeFile(ev) {
          var blob = ev.target.files[0];
          heic2any({
              blob: blob,
              toType: "image/png",
            })
              .then(function (resultBlob) {
                saveFile(resultBlob, blob.name + ".png");
              })
              .catch(function (x) {
                document.getElementById("error-on-try").style.display = "block";
                document.getElementById("error-on-try").innerHTML =
                  "Error code: <code>" + x.code + "</code> " + x.message;
              });

        },
        async uploadFileFunction(e) {
            const files = e.target.files || e.dataTransfer.files;
            console.log(files)
            this.uploadFile = files[0];
            let formData = new FormData();
            formData.append('file', this.uploadFile);
            let config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };
                            // var res = await axios.post("/api/owner/check/creditcard", form);
            await axios
                .post(this.apiUrl, formData, config)
                .then(function(response) {
                    // response 処理
                    location.reload()

                })
                .catch(function(error) {
                    // error 処理
                    alert('アップロードエラー')
                })

        }
    }
}
</script>
